export default __webpack_public_path__ + "static/slika3-207406d02818323797f923729929d0ca.jpg";